// istanbul ignore file
'use client';

import { type PropsWithChildren, useEffect } from 'react';

import { useAccount } from 'reservations/account/providers/AccountProvider';
import { useAcceptsReservations } from 'reservations/account/providers/ConfigProvider';
import { usePageTitle } from 'reservations/account/providers/PageTitleProvider';
import { useQueryParams } from 'reservations/base/hooks/useQueryParams';

// istanbul ignore file

// istanbul ignore file

// istanbul ignore file

export const RESERVATIONS = 'Reservations';
export const WAITLIST = 'Waitlist';

// TODO: DMD-5737 - Replace PageTitleHandler with this component
export const PageTitleHandler = ({ children }: PropsWithChildren) => {
  const isAcceptingReservations = useAcceptsReservations();
  const { favicon_url: faviconUrl, restaurantName } = useAccount();
  const { setFaviconUrl, setFeature, setRestaurant } = usePageTitle();
  const { slug } = useQueryParams();

  const isLocationListScreen = !slug;
  const currentFeature = isAcceptingReservations ? RESERVATIONS : WAITLIST;

  useEffect(() => {
    if (
      !isLocationListScreen ||
      (isLocationListScreen && isAcceptingReservations)
    ) {
      setFeature(currentFeature);
    }
  }, [currentFeature, isAcceptingReservations, isLocationListScreen, slug]);

  useEffect(() => {
    if (faviconUrl) {
      setFaviconUrl(faviconUrl);
    }
  }, [faviconUrl]);

  useEffect(() => {
    if (restaurantName) {
      setRestaurant(restaurantName);
    }
  }, [restaurantName]);

  return <>{children}</>;
};
